import { render, staticRenderFns } from "./EndService.vue?vue&type=template&id=c4ba246a"
import script from "./EndService.vue?vue&type=script&lang=js"
export * from "./EndService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports